import { CACHE_TTL, CURRENCY_CODE, getCurrencySymbol } from '@ps/utils';

import { CompanySettings } from '../models/settings.model';
import { UserSettingsState } from './user-settings.model';
import { CurrencySettings } from '../models/currency-settings.model';

export const INITIAL_COMPANY_SETTINGS: Partial<CompanySettings> = {
  fx: CURRENCY_CODE.US,
  currencySymbol: getCurrencySymbol(CURRENCY_CODE.US),
};

export const INITIAL_CURRENCY_EXCHANGE_SETTINGS: CurrencySettings = {
  code: 'USD',
  name: 'US Dollar',
  rate: 1,
  crRate: 0,
  symbol: '$',
  fx: CURRENCY_CODE.US,
};

export const DASHBOARD_CACHE_TTL = CACHE_TTL.LONG;
export const REPORT_PREFERENCE_CACHE_TTL = CACHE_TTL.SESSION;
export const BILLING_RULES_CACHE_TTL = CACHE_TTL.LONG;

export const INITIAL_USER_SETTINGS_STATE: UserSettingsState = {
  allBuyerSettings: {},
  companySettings: INITIAL_COMPANY_SETTINGS,
  currencySettings: null,
  entitlements: [],
  loading: false,
  error: null,
  preferences: [],
  preferencesLoading: false,
  preferencesError: null,
  preferencesCachedAt: null,
  reportPreferences: [],
  reportPreferencesLoading: false,
  reportPreferencesError: null,
  reportPreferencesCachedAt: null,
  billingRuleRecord: null,
  billingRulesCachedAt: null,
};
